"use client";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import { usePortal } from "@travel/shared/hooks";
import styles from "./scrim.module.css";
export function Scrim(_a) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.open, open = _c === void 0 ? false : _c, _d = _a.zIndex, zIndex = _d === void 0 ? 2147483647 : _d, _e = _a.portal, renderPortal = _e === void 0 ? false : _e, _f = _a.closeOnClick, closeOnClick = _f === void 0 ? false : _f, _g = _a.allowClickThrough, allowClickThrough = _g === void 0 ? false : _g, onClick = _a.onClick, onOpen = _a.onOpen, onClose = _a.onClose;
    var _h = __read(useState(open), 2), isOpen = _h[0], setIsOpen = _h[1];
    var _j = __read(useState(open), 2), isVisible = _j[0], setIsVisible = _j[1];
    var portal = usePortal("scrims");
    var scrimRef = useRef(null);
    useEffect(function () {
        setIsOpen(open);
    }, [open]);
    var scrim = (_jsx(CSSTransition, { in: isOpen, nodeRef: scrimRef, timeout: 300, unmountOnExit: true, classNames: {
            enter: styles["scrim-enter"],
            enterActive: styles["scrim-enter-active"],
            exit: styles["scrim-exit"],
            exitActive: styles["scrim-exit-active"],
        }, onEnter: function () { return setIsOpen(true); }, onExit: function () {
            setIsOpen(false);
        }, children: _jsx("div", { className: classNames(styles["scrim"], className, (_b = {},
                _b[styles["is-open"]] = isOpen,
                _b)), style: { zIndex: zIndex, pointerEvents: allowClickThrough ? "none" : "auto" }, onClick: handleClick, ref: scrimRef, children: children }) }));
    return portal && renderPortal ? createPortal(scrim, portal) : scrim;
    function handleClick(event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        if (closeOnClick) {
            setIsOpen(false);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }
}
